(function() {

  'use strict';

  function Cep($rootScope, $http, $q, $filter, API_TOKEN, CepResource) {

    var Cep = {};
    var veiculos = [];
    var dadosColeta = {};

    var setVeiculos = function(novosVeiculos) {
      veiculos = novosVeiculos;
    };

    var setDadosColeta = function(dados) {
      dadosColeta = dados;

      var veiculos = [];
      for (var i = 0; i < dados.veiculos.length; i++) {
        veiculos.push({ veiculo: dados.veiculos[i] });
      }

      setVeiculos(veiculos);
    };

    Cep.obsColeta = function() {
      return dadosColeta.observacao;
    }

    Cep.diaAdicional = function() {
      return dadosColeta.diaAdicional;
    }

    Cep.temCarro = function() {
      var carro = $filter('filter')(veiculos, {
        veiculo: "Carro"
      }, true)[0];

      return carro != null;
    };

    /**
     * Retorna endereço por cep.
     *
     * @param  {Object}   cep     - cep
     * @param  {Function} callback - optional
     * @return {Promise}
     */
    Cep.buscaEnderecoPorCep = function(cep, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      return CepResource.get({
          cep: cep
        },
        function(data) {
          deferred.resolve(data);
          return cb();
        },
        function(err) {
          return cb(err);
        }.bind(this)).$promise;
    };

    /**
     * Retorna Shipping Options por cep.
     *
     * @param  {Object}   cep     - cep
     * @param  {Function} callback - optional
     * @return {Promise}
     */
    // Cep.buscaTipoEntregaPorCep = function(cep, timeout, tipoPessoa, callback) {
    Cep.buscaTipoEntregaPorCep = function(cep, tipoPessoa, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      return CepResource.shippingOptions({
          cep: cep,
          // timeout: timeout,
          pj: tipoPessoa
        },
        function(data) {
          deferred.resolve(data);
          return cb();
        },
        function(err) {
          return cb(err);
        }.bind(this)).$promise;
    };

    Cep.buscarTipoVeiculoPorCep = function(cep, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      return CepResource.veiculos({
          cep: cep
        },
        function(veiculos) {
          setVeiculos(veiculos);
          deferred.resolve(veiculos);
          return cb();
        },
        function(err) {
          return cb(err);
        }.bind(this)).$promise;
    };

    Cep.buscarTipoVeiculoPorCepDadosColeta = function(cep, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      return CepResource.veiculosDadosColeta({
          cep: cep
        },
        function(dados) {
          setDadosColeta(dados);
          deferred.resolve(veiculos);
          return cb();
        },
        function(err) {
          return cb(err);
        }.bind(this)).$promise;
    };

    return Cep;
  };

  angular.module('mandaeApp')
    .factory('Cep', Cep);

})();
